export default "__VITE_ASSET__LZPowk7S__"